import React, { PureComponent } from 'react';

import uuid from 'uuid/v4';

import { Endpoint, ToastService } from '@philips-emr/hpms-provider-commons';
import providerContext from '@philips-emr/hpms-provider-commons/lib/context/provider-context';
import { Card, Field, Form, Input, Text } from '@philips-emr/tws-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener } from '@philips-emr/tws-core/lib/component/prop-types';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';

import './hpms-amount-professionals.css';
import { HPMSAmountProfessionalsCardAPI } from '../../api';

@AwesomeComponent({ api: HPMSAmountProfessionalsCardAPI,  type: ComponentType.DATA_DISPLAY })
class HPMSAmountProfessionalsCard extends PureComponent {

  static propTypes = {
    onAfterSubmitAmountProfessionalsCard: eventListener,
  }

  state = {
    editForm: false,
    record: {},
  };

  componentDidMount() {
    this.setState({ record: this.props });
  }

  render() {
    const { record: data } = this.state;
    const isMandatory = data.mandatory === 'S' ? true : false;
    const modeEdition = this.state.editForm || (!!data.amounts || data.amounts === 0) ? false : true;
    const locked = data.editable === 'N';

    return(
      <Card width={12} uuid={uuid()} className="card-document-style">
        <Form
          locked={locked}
          editing={locked ? false : modeEdition}
          uuid={uuid()}
          data={data}
          onEdit={() => this.setState({ editForm: true })}
          onCancel={() => this.setState({ editForm: false })}
          onSubmit={(event) => this.onSubmit(event)}>
          <Field width={8} uuid={uuid()} alwaysShowLabel label="provider.occupation" entry="dsOccupation">
            <Text />
          </Field>
          { this.state.editForm
          ? <Field width={4} uuid={uuid()} alwaysShowLabel label="provider.amount" entry="amounts" validators={this.getValidatorAmount(isMandatory)}>
              <Input uuid={uuid()} placeholder="provider.amount" type="number" length={10} showLength={false}/>
            </Field>
          : <Field width={4} uuid={uuid()} alwaysShowLabel label="provider.amount" entry="amounts">
              <Input uuid={uuid()} placeholder="provider.amount" type="number" length={10} showLength={false}/>
            </Field>
          }
        </Form>
      </Card>
    );
  }

  getValidatorAmount(isMandatory) {
    return isMandatory ? [{ name: 'required' }] : [];
  }

  onSubmit(event) {
    const { record }  = event;
    const { nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    HttpService.post(Endpoint.POST.AMOUNT_PROFESSIONALS, { nrSeqProvider, nrSeqAccreditation }, { body: { ...record } })
    .then(() => {
      this.setState({ editForm: false });
      this.onAfterSubmit();
    }).catch((response) => ToastService.open(response));
  }

  onAfterSubmit() {
    const { onAfterSubmitAmountProfessionalsCard } = this.props;
    onAfterSubmitAmountProfessionalsCard();
  }
}

export {
  HPMSAmountProfessionalsCard,
};
